import { environment as sharedEnvironment } from "./environment.shared";

export const environment = {
  ...sharedEnvironment,
  production: false
};
